module.exports = __webpack_public_path__ + "img/视频封面20.fe5fe4bf.png";